import { features } from 'reactApp/mail-features';

export const overquotaNewUnsub = features.getAsJSONWithDefaults('overquota-new-unsub', {
    enable: false,
    foldersCount: 5,
    helpURL: 'https://help.mail.ru/cloud_web/files/overflowing/',
    mailURL: 'https://e.mail.ru',
    cloudURL: '/home',
} as {
    // Включаем новый флоу отписки для оверквотников?
    enable: boolean;
    // Сколько папок/файлов максимально показываем в модалке-предупреждалке
    foldersCount: number;
    // Ссылка на статью в хелпе с переполнением квоты
    helpURL: string;
    // Ссылка на почту
    mailURL: string;
    // Ссылка на хомяка
    cloudURL: string;
});

export const updatedUnsubScreensEnabled = features.has('updated-unsub-screens-enabled');
